// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bar[data-v-7507bf1a] {\n  border-radius: var(--magic-space--small, 8px);\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
